import './AllAOs.scss';

import { Button } from '@mui/material';
//import Button from '@mui/material/Button';
import React, { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
//import { forwardRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import DialogAnnulerPublication from '../../../Components/Dialogs/DialogAnnulerPublication';
import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import useGetRequest from '../../../hooks/useGetRequest';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useWindowSize from '../../../hooks/useWindowSize';
// import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, getStatutAO, sortDatePublication } from '../../../Utils/utils';
import { countCandidatureByStatus } from '../../Admin/AOs/AllAOs';

const AllMyAOs = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const { i18n } = useTranslation();

    const columns =[
        {
            field: 'aoId',
            title: i18n.t('Réf. AO'),
        },
        {
            field: 'referenceInterne',
            title: i18n.t('Code int. Client'),
        },
        {
            field: 'intitulePoste',
            title: i18n.t('Intitulé'),
        },
        {
            field: 'statutAo',
            title: i18n.t('Statut'),
        },
        {
            field: 'nbCandidatures',
            title: i18n.t('Nb. de candidatures'),
        },
        {
            field: 'countInterviewed',
            title: i18n.t('Candidatures "à interviewer"'),
        },
        {
            field: 'countRetained',
            title: i18n.t('Candidatures "Retenues"'),
        },
        {
            field: 'nbRecrutes',
            title: i18n.t('Nb. de recrutement'),
        },
        {
            field: 'dureeBdc',
            title: i18n.t('Durée du BDC'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureeBDC,'mois');
            }
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début Mission'),
            render: (rowData) => {
                return <>
                    {formatDateJJMMYYYY(rowData?.dateDebutMission)}
                </>;
            }
        },
        {
            field: 'dateFinMission',
            title: i18n.t('Date fin Mission'),
            render: (rowData) =>{
                return <>
                    {formatDateJJMMYYYY(rowData?.dateFinMission)}
                </>;
            }
        },
        {
            field: 'budgetMax',
            title: i18n.t('Budget Max/j'),

        },
        {
            field: 'creePar',
            title: i18n.t('AO Créé par'),

        },
        {
            field: 'respoOper',
            title: i18n.t('Resp. opérationnel'),
        },
        {
            field: 'dateDebutAO',
            title: i18n.t('Début publication'),
            render: (rowData) =>{
                return <>
                    {formatDateJJMMYYYY(rowData?.dateDebutAO)}
                </>;
            }
        },
        {
            field: 'dateFinAO',
            title: i18n.t('Fin publication'),
            render: (rowData) =>{
                return <>
                    {formatDateJJMMYYYY(rowData?.dateFinAO)}
                </>;
            }
        },
    ];
    const {data: aos,refresh} = useGetRequest({url: '/ao/getMyAOs',propertyName: 'myAOs'});
    const [selectedAOs, setSelectedAOs] = useState([]);
    const [arrayAOs,setArrayAOs]=useState();
    const [openValiderAnnulation, setOpenValiderAnnulation] = useState(false);
    const {device}=useWindowSize();
    const location = useLocation();
    const role=useRole();
    const searchParams = new URLSearchParams(location.search);
    const [filtre, setFiltre] = useState(searchParams.get('filtre') === 'true');
    const [filtreCandidatInterview, setFiltreCandidatInterview] = useState(searchParams.get('filtreCandidatInterview') === 'true');
    const [filtreCandidatUnread, setFiltreCandidatUnread] = useState(searchParams.get('filtreCandidatUnread') === 'true');
    const [url, setUrl] = useState('');
    const [selectedRow, setSelectedRow] = React.useState(null);

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtre') && !url.toLowerCase().includes('filtrecandidatunread') && !url.toLowerCase().includes('filtrecandidatinterview') ){
            setFiltre(false);
            setFiltreCandidatUnread(false);
            setFiltreCandidatInterview(false);
        }
    }, [url]);

    useEffect(() => {
        refresh();
    }, [filtre,filtreCandidatInterview,filtreCandidatUnread]);

    const testElementIfContainsClosePublication=(selectedAOs)=>{
        let result=false;
        for (const ao of selectedAOs) {
            if (ao?.statutAo === 'Clôturé') {
                result = true;
                break;
            }
        }
        console.log('result :',result);
        return result;
    };
    const mapAo = (ao) => {
        const temp=i18n.t(getStatutAO(ao?.dateDebutAO, ao?.dateFinAO));
        return {
            'aoId': ao?.aoId,
            'referenceInterne': ao?.referenceInterne,
            'intitulePoste':ao?.intitulePoste,
            'statutAo':temp,
            'nbCandidatures':ao?.candidatures?.length,
            'countInterviewed': countCandidatureByStatus(ao?.candidatures)?.countInterviewed,
            'countRetained': countCandidatureByStatus(ao?.candidatures)?.countRetained,
            'nbRecrutes':ao?.nbRecrutes,
            'budgetMax': ao?.tjMax ? ao?.tjMax+ ' €' :'Non précisé',
            'creePar': ao?.collaboratorId?.persoData
                ? getNomPrenomClearFromPersoData(ao?.collaboratorId?.persoData)
                : ao?.collaboratorEsnId?.persoData
                    ? getNomPrenomClearFromPersoData(ao?.collaboratorEsnId?.persoData)
                    : 'Back Office',
            'respoOper':getNomPrenomClearFromPersoData(ao?.entrepriseData?.responsableOperationnelId?.persoData ?? ao?.entrepriseData?.responsableOperationnelEsnId?.persoData),
            'dureeBdc':ao?.dureeBDC,
            'dateDebutMission': ao?.dateDebutMission,
            'dateFinMission': ao?.dateFinMission,
            'dateDebutAO': ao?.dateDebutAO,
            'dateFinAO': ao?.dateFinAO,
            ...ao,
        };
    };
    // ! when the CORS error wfixed : in case of refresh token expired
    const navigate = useNavigate();
    useEffect(() => {
        if (aos) {
            let aoArrayTemp = [];
            let sortedListByDate;
            let temp;
            let temp_interviewed;
            let temp_unread;
            if(filtre==true){
                aos?.reverse().forEach(ao => {
                    if(temp=='Publié'){
                        aoArrayTemp.push(mapAo(ao));
                    }
                });
                sortedListByDate=sortDatePublication(aoArrayTemp,'dateDebutAO');
            }
            else if (filtreCandidatInterview==true){
                aos?.reverse().forEach(ao => {
                    temp_interviewed=countCandidatureByStatus(ao?.candidatures)?.countInterviewed;
                    if(getStatutAO(ao?.dateDebutAO, ao?.dateFinAO)=='Publié' && temp_interviewed>0){
                        aoArrayTemp.push(mapAo(ao));
                    }
                });
                sortedListByDate=sortDatePublication(aoArrayTemp,'dateDebutAO');
            }
            else if (filtreCandidatUnread==true){
                aos?.reverse().forEach(ao => {
                    temp_unread=countCandidatureByStatus(ao?.candidatures)?.countUnread;
                    console.log('temp_unread',temp_unread);
                    if(getStatutAO(ao?.dateDebutAO, ao?.dateFinAO)=='Publié' && temp_unread>0){
                        aoArrayTemp.push(mapAo(ao));
                    }
                });
                sortedListByDate=sortDatePublication(aoArrayTemp,'dateDebutAO');
            }
            else{
                aos?.reverse().forEach(ao => {
                    aoArrayTemp.push(mapAo(ao));
                });
                sortedListByDate=sortDatePublication(aoArrayTemp,'dateDebutAO');
            }
            setArrayAOs(sortedListByDate);
        }
    }, [aos]);

    return (
        <div
            className='Frame1AllAOs'
        >
            <div className='frame5Profile'>{role=='esn' ? i18n.t('Mes appels d\'offres'): i18n.t('Appels d\'offres')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('AO et candidatures')} </span> </div>
            <div className='Frame2AllAOs'>
                <h4 className='titlesociete'>
                    {i18n.t('Appels d\'offres ouverts')}
                </h4>
                <div className='Frame3AllAOs'>
                    <Button
                        variant="contained"
                        disabled={((selectedAOs.length>0 && testElementIfContainsClosePublication(selectedAOs)==false) ? false : true)}
                        style={{...buttonStylesGreen(((selectedAOs.length>0 && testElementIfContainsClosePublication(selectedAOs)==false)? false : true)),...{width:device=='desktop'? '181px':'100%'}}}
                        onClick={()=> (selectedAOs.length > 0) && setOpenValiderAnnulation(true)}
                    > {i18n.t('Clôturer la publication')}
                    </Button>
                </div>
            </div>
            <MaterialTableComponent
                columns={columns}
                data={arrayAOs}
                title={i18n.t('Appels d\'offres ouverts')}
                onRowClick={(event, rowData) => {
                    if(role!='esn')
                        navigate(`/${role}/ao/${rowData?._id}`);
                    else
                        navigate(`/${role}/ao/details/${rowData?._id}`);
                    setSelectedRow(rowData?.tableData.id);
                }}
                selectedRow={selectedRow}
                options={{
                    selection: true
                }}
                onSelectionChange={(rows) => {
                    console.log({rows});
                    setSelectedAOs(rows);
                }}
            />
            {openValiderAnnulation &&
                <DialogAnnulerPublication
                    selectedAOs={selectedAOs}
                    openValiderAnnulation={openValiderAnnulation}
                    setOpenValiderAnnulation={setOpenValiderAnnulation}
                    refresh={refresh}
                />
            }
            {/*<div className='Frame4AllAOs'>
                <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                        icons={tableIcons}
                        columns={columns}
                        data={arrayAOs}
                        title="Appels d'offres ouverts"
                        options={materialTableOptions}
                        onRowClick={(event, rowData) => {
                            navigate(`/client/ao/${rowData?._id}`,
                                // {
                                //     state: {
                                //         rowData
                                //     }
                                // }
                            );
                        }}
                    />
                </ThemeProvider>
            </div>*/}
        </div>
    );
};
export default AllMyAOs;

{/* <div className='Frame4AllAOs'>
            <ReactTable
                data={arrayAOs}
                onClick={() => {
                    // + ao?.aoId
                    // ! maybe the approach of passing data to next page works for the specific client, since he won't have at most 20 AO for eg, but for experts or BackOffices, we need to do another request
                    navigate('/client/ao',
                        {
                            state: {
                                ao
                            }
                        }
                    );
                }}
                columns={columns}
                defaultPageSize = {5}
                pageSizeOptions = {[2,4, 6]}
            />

        </div> */}

{/*<Table

    striped
    bordered
    hover
    // responsive
>
    <thead>
        <tr>
            <th>Code internehj</th>
            <th>code externe</th>
            <th>intitule de l AO</th>
            <th>statut</th>
            <th>nombre de candidats</th>
            <th>nombre de Recrutement</th>
            <th>Date de début souhaité</th>
            <th>Créé par</th>
            <th>nom de manager Op</th>
            <th>Début de publication</th>
            <th>fin de publication</th>
        </tr>
    </thead>
    {aos?.length
        ? (
            <tbody>
                {aos.map((ao, i) => (
                    <tr key={i}                                >
                        <td
                            onClick={() => {
                                // + ao?.aoId
                                // ! maybe the approach of passing data to next page works for the specific client, since he won't have at most 20 AO for eg, but for experts or BackOffices, we need to do another request
                                navigate('/client/ao',
                                    {
                                        state: {
                                            ao
                                        }
                                    }
                                );
                            }}
                        >🔎 {ao?.aoId}</td>
                        <td>{ao?.referenceInterne}</td>
                        <td>{ao?.intitulePoste}</td>
                        <td>{ao?.statutAO}</td>
                        <td>{ao?.candidatures?.length}</td>
                            // ! We need to calculate it and not store it directly, nbr des candidature where status = retenue.
                        <td>
                            {
                                ao?.candidatures?.map(function (candidat) {
                                    return (
                                        <React.Fragment key={candidat?._id}>
                                            {candidat?.status == 'retenu' ?
                                                '✔' : '✖'}
                                        </React.Fragment>
                                    );
                                })}
                            /{ao?.nbRecrutes}</td>
                        //! OLD <td>{ao?.dateDebutMission}</td>
                        <td>{formatDateJJMMYYYY(ao?.dateDebutMission)}</td>
                        <td>{ao?.collaboratorId?.persoData?.nom + ' ' + ao?.collaboratorId?.persoData?.prenom}</td>
                        <td>{ao?.entrepriseData?.managerProjet}</td>
                        <td>{formatDateJJMMYYYY(ao?.dateDebutAO)}</td>
                        <td>{formatDateJJMMYYYY(ao?.dateFinAO)}</td>
                    </tr>
                ))}
            </tbody>
        ) : <p>aucun appel d offre  a afficher</p>
    }
</Table>*/}
